import type { DetalheDte, DteResposta } from './canvas';

import useSWR from 'swr';
import { useNavigate } from 'react-router';

import Box from '@mui/material/Box';

import { fetcher } from 'src/lib/axios';
import { DashboardContent } from 'src/layouts/dashboard/content';
import { DsButton, DsPageHeader, DsStatusChip } from 'src/auditoria/components/ds';

import { SX_COLUNAS, RailCiencia, CardMensagem, GradeNotificacoes } from './canvas';

// ----------------------------------------------------------------------
// DTE → Notificações (artboard `portal-dte`). Backend: GET /portal-api/dte —
// caixa de entrada do contribuinte, com ciência que emite Protocolo de
// Recebimento p/ Notificação/Intimação.
//
// O canvas tem três blocos: grade à esquerda, card da última mensagem abaixo
// dela e o rail de 300px "Ciência e protocolo" à direita.
// ----------------------------------------------------------------------

export default function DteListPage() {
  const navigate = useNavigate();
  const { data, isLoading, mutate } = useSWR<DteResposta>('/portal-api/dte', fetcher);
  const mensagens = data?.mensagens ?? [];
  const naoLidas = data?.naoLidas ?? 0;

  // O card de mensagem do artboard mostra uma notificação JÁ CIENTE. Pré-visualizar
  // uma não lida seria registrar ciência sem o contribuinte pedir — o GET do
  // detalhe é o ato de ciência. Por isso a prévia é sempre a mensagem mais
  // recente já lida; se não houver nenhuma, o bloco simplesmente não aparece.
  const previa = mensagens.find((m) => m.lida);
  const { data: detalhe } = useSWR<DetalheDte>(
    previa ? `/portal-api/dte/${previa.id}` : null,
    fetcher
  );

  const abrirProtocolo = (assuntoId?: number) =>
    navigate(assuntoId ? `/protocolo/novo?assunto=${assuntoId}` : '/protocolo/novo');

  return (
    <DashboardContent>
      <DsPageHeader
        weight={800}
        title="Notificações"
        subtitle="Caixa de entrada do Domicílio Tributário Eletrônico · abrir registra ciência e emite Protocolo de Recebimento."
        action={
          <Box sx={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
            <DsStatusChip tone={naoLidas > 0 ? 'warning' : 'default'}>
              {naoLidas} não lidas
            </DsStatusChip>
            <DsButton tone="neutral" size="tall" icon="atualizar" onClick={() => mutate()}>
              Atualizar
            </DsButton>
          </Box>
        }
      />

      <Box sx={SX_COLUNAS}>
        <Box sx={{ flex: 1, minWidth: 0 }}>
          <GradeNotificacoes
            mensagens={mensagens}
            carregando={isLoading}
            aoAbrir={(row) => navigate(`/notificacoes/${row.id}`)}
          />

          {detalhe && (
            <CardMensagem
              detalhe={detalhe}
              aoContestar={(assuntoId) => abrirProtocolo(assuntoId)}
            />
          )}
        </Box>

        <RailCiencia
          mensagens={mensagens}
          naoLidas={naoLidas}
          aoAbrirProtocolo={() => abrirProtocolo()}
        />
      </Box>
    </DashboardContent>
  );
}
